require('./addImpositionDepositView.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const { withRouter } = require('react-router-dom');
// @ commons
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { FormattedText, formatText } = require('core/i18n').i18n;
// @ helpers
const { getAccountByImposition } = require('utilities/currentAccountsHelper.js');
const { getLastNChars } = require('utilities/stringHelper');
// @ components
const ImpositionSidebar = require('components/imposition/impositionSidebar/impositionSidebar');
const { LoadingSection } = require('commonsComponents/loadingSection');
const AddImpositionDepositStep1 = require('components/contactCenter/addImpositionDepositSteps/addImpositionDepositStep1/addImpositionDepositStep1');
const CustomMessageBox = require('components/contactCenter/customMessageBox/customMessageBox');
const PreLeaveModalComponent = require('components/preLeaveModalComponent/preLeaveModalComponent');
const OKHeaderCC = require('components/commons/OKHeaderCC/OKHeaderCC');
const VerifyOtpStep = require('components/commons/verifyOtpStep/verifyOtpStep');
// @ actions
const addImpositionDepositActions = require('actions/contactCenter/addImpositionDepositActions');
const depositsActions = require('actions/deposits');
const intervenersActions = require('actions/getAccountInterveners');
// @ constants
const { WIZARD_VERTICAL_VIEW_MODE, FIRST_STEP, API_ENTERPRISE_NUMBER, API_CENTER, } = require('constants/index');
const { ADD_DEPOSIT_IMPOSITION } = require('constants/operationTypes');

class AddImpositionDepositView extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.beforeLeaving = this.beforeLeaving.bind(this);
        this.handleFinish = this.handleFinish.bind(this);
        this.onHandleCancel = this.onHandleCancel.bind(this);
        this.setValue = this.setValue.bind(this);
        this.isReady = this.isReady.bind(this);
    }

    componentDidMount() {
        const { match: { params: { depositId } }, getDepositDetails, requestDeposits } = this.props;

        if (!this.props.immDeposits.get('byId')) {
            requestDeposits();
        } else {
            getDepositDetails(depositId);
            this.getInterveners(this.props);
        }
    }

    componentWillReceiveProps(nextProps) {
        const { match: { params: { depositId } }, getDepositDetails } = this.props;

        if (
            !nextProps.immDeposits.get('isFetching') &&
            nextProps.immDeposits.get('success')
        ) {
            const accountId = this.getAccountId(nextProps);
            const impositionDetail = nextProps.immDepositDetails.toJS();
            const interveners = nextProps.immAccounts.getIn(['byId', accountId, 'interveners']).toJS();

            if (
                !impositionDetail.hasBeenFetched &&
                !impositionDetail.isFetching &&
                !impositionDetail.error
            ) {
                getDepositDetails(depositId);
            }

            if (
                !interveners.hasBeenFetched &&
                !interveners.isLoading &&
                !interveners.error
            ) {
                this.getInterveners(nextProps);
            }
        }
    }

    componentWillUnmount() {
        const { reset } = this.props;
        reset();
    }

    getAccountId(props) {
        const {
            params: { depositId },
            immDeposits,
            immAccounts
        } = props;

        const immImpositionAssociatedAccount = immDeposits.getIn(['byId', depositId, 'impositionAssociatedAccount']);
        const immAccount = getAccountByImposition(immImpositionAssociatedAccount, immAccounts);

        return immAccount.get('accountId');
    }

    getInterveners(nextProps) {
        const accountId = this.getAccountId(nextProps);

        this.props.requestInterveners(accountId);
    }

    isReady() {
        const { immImpositionState } = this.props;
        !immImpositionState.get('isFetching');
    }

    onHandleCancel() {
        this.props.history.push(`/myprofile/deposits`);
    }

    handleFinish() {
        const { match: { params: { depositId } }, addImpositionConf } = this.props;
        addImpositionConf(depositId);
    }

    hasDeposits() {
        const { immDeposits } = this.props;

        return immDeposits.get('byId') && immDeposits.get('success');
    }

    buildCustomMessageBoxSuccess() {
        const title = formatText('addImposition-confirmationSuccessTitle');
        const subtitle = formatText('addImposition-confirmationSuccessSubtitle');
        const textLink = formatText('addImposition-confirmationBackbtn');

        return (
            <CustomMessageBox
                icon="icon-success"
                title={title}
                subtitle={subtitle}
                goBackHandler={this.onHandleCancel}
                textLink={textLink}
            />
        )
    }

    buildCustomMessageBoxError() {
        const title = formatText('addImposition-confirmationErrorTitle');
        const subtitle = formatText('addImposition-confirmationErrorSubtitle');
        const textLink = formatText('addImposition-confirmationBackbtn');

        return (
            <CustomMessageBox
                icon="icon-warning"
                title={title}
                subtitle={subtitle}
                goBackHandler={this.onHandleCancel}
                textLink={textLink}
            />
        )
    }

    setValue(event) {
        this.props.setDepositValue(event);
    }

    buildWizard() {
        const {
            match: { params: { depositId } },
            immDeposits,
            validateStep,
            immProfileFields,
            immImpositionState,
            immAccounts,
            setVisibleStep,
            setWillCancel,
            updateRenewalPreference,
            immDepositDetails } = this.props;
        const immSteps = immImpositionState.get('steps');

        const stepsAmount = immSteps.size;

        const actions = {
            validateStep: () => validateStep(depositId),//Uncomment this line once the services work properly
            setVisibleStep,
            setWillCancel,
            finish: this.handleFinish,
            cancel: this.onHandleCancel
        };

        const visibleStep = immImpositionState.get('visibleStep');
        const immStepOne = immImpositionState.getIn(['steps', FIRST_STEP]);
        const depositValue = immStepOne.get('depositValue');
        const errorState = immStepOne.get('errorState');
        const immFinalButton = 'sendN1PasswordStep1-confirmBtn';
        const immDeposit = immDeposits.getIn(['byId', depositId]);
        const isFetching = immImpositionState.get('isFetching');
        const isFetchingValidation = immImpositionState.get('isFetchingValidation');
        const originAccount = API_ENTERPRISE_NUMBER.concat(
            API_CENTER,
            immDeposit.getIn(['contract', 'product']),
            immDeposit.getIn(['contract', 'contractNumber'])
        );
        const currency = immDeposit.getIn(['amount', 'currency']);


        const operationParams = {
            originAccount,
            ammount: depositValue,
            currency
        };

        return (
            <Wizard
                wizardClass="account-modify__wizard"
                actions={actions}
                immSteps={immSteps}
                stepsAmount={stepsAmount}
                visibleStep={visibleStep}
                fullWidth={false}
                viewMode={WIZARD_VERTICAL_VIEW_MODE}
            >
                <WizardStep
                    position="first"
                    cancelButton={true}
                    isLoading={isFetchingValidation}
                    rightIconModifier={false}
                    nextBtnModifier="primary"
                >
                    <AddImpositionDepositStep1
                        immAccounts={immAccounts}
                        immStep={immSteps.get(0)}
                        immDeposit={immDeposit}
                        immProfileFields={immProfileFields}
                        immDepositDetails={immDepositDetails}
                        setDepositValue={this.setValue}
                        depositId={depositId}
                        depositValue={depositValue}
                        errorState={errorState}
                        updateRenewalPreference={updateRenewalPreference}
                    />
                </WizardStep>
                <WizardStep
                    addLoadingBehaviour={true}
                    position="last"
                    cancelButton={true}
                    isLoading={isFetching}
                    finishButton={true}
                    immFinalButton={immFinalButton}
                >
                    <VerifyOtpStep
                        operationType={ADD_DEPOSIT_IMPOSITION}
                        operationParams={operationParams}
                        withValidateButton={false}
                    />
                </WizardStep>
            </Wizard>
        );
    }

    beforeLeaving() {
        const { immImpositionState, reset } = this.props;
        if (immImpositionState.get('submitSuccessful') && immImpositionState.get('willLeave')) {
            reset();
        }
    }

    render() {
        const { match: { params: { depositId } }, immImpositionState, immDeposits, immAccounts, immDepositDetails } = this.props;
        const pageTitle = formatText('accountModifyStep-pageTitle');

        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-deposits'),
                url: '/myprofile/deposits'
            },
            {
                text: formatText('addImposition-pageTitle')
            }
        ]

        let content;

        if (immDepositDetails.get('isFetching')) {
            content = (
                <LoadingSection />
            );
        }
        else if (immImpositionState.get('error') || immDepositDetails.get('error')) {
            content = this.buildCustomMessageBoxError();
        } else if (immImpositionState.get('submitSuccessful')) {
            content = this.buildCustomMessageBoxSuccess();
        } else if (this.hasDeposits() && immDeposits.getIn(['byId', depositId]).getIn(["impositionAssociatedAccount", "contractNumber"]).length > 0) {
            const wizard = this.buildWizard();
            const confirmationMessage = formatText('preleaveCancelModal-confirmationMessagePreleave');
            const confirmationTitle = formatText('preleaveCancelModal-confirmationTitleMessagePreleave');
            const acceptText = formatText('preleaveCancelModal-cancelButton');
            const cancelText = formatText('preleaveCancelModal-stayHereButton');
            const immDeposit = immDeposits.getIn(['byId', depositId]);
            const fullContractNumber = immDeposit.getIn(['contract', 'fullContractNumber']);
            const immImpositionAssociatedAccount = immDeposit.get('impositionAssociatedAccount');
            const immAccount = getAccountByImposition(immImpositionAssociatedAccount, immAccounts);
            const immInterveners = immAccount.getIn(['interveners', 'list']);
            const alias = immAccount.get('alias');
            const iban = immAccount.get('iban');
            const account = alias + " " + getLastNChars(iban);
            const passContent = (
                <div>
                    <PreLeaveModalComponent
                        confirmationMessage={confirmationMessage}
                        confirmationTitle={confirmationTitle}
                        acceptText={acceptText}
                        cancelText={cancelText}
                        isReady={this.isReady}
                        beforeLeaving={this.beforeLeaving}
                        onConfirmLeave={this.handleConfirmLeave}
                    />
                    {wizard}
                </div>
            );

            content = (

                <section className="deposit-imposition-view__body">
                    <div className="col-xs-8">
                        <div className="deposit-imposition-view__body-header">
                            <FormattedText value="addImposition-pageTitle" />
                        </div>
                        {passContent}
                    </div>
                    <div className="col-xs-4">
                        <div className="deposit-imposition-view__body-header">
                            <FormattedText value="addImposition-rightSideDepositTitle" />
                        </div>
                        <ImpositionSidebar
                            title={immDeposit.get('description')}
                            amountObject={immDeposit.get('amount')}
                            contractNumber={fullContractNumber}
                            account={account}
                            immInterveners={immInterveners}
                            depositId={depositId}
                            immDeposits={immDeposits}
                        />
                    </div>
                </section>
            )
        }

        return (
            <article className="deposit-imposition-view">
                <OKHeaderCC
                    title={pageTitle}
                    breadcrumbConfig={mappingBreadcrumb}
                    showBreadBrumb={true}
                />
                {content}
            </article>
        );
    }
}

AddImpositionDepositView.propTypes = {
    history: PropTypes.object.isRequired,
    immProfileFields: PropTypes.object,
    immImpositionState: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immDeposits: PropTypes.object.isRequired,
    immDepositDetails: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    addImpositionValidation: PropTypes.func,
    reset: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setDepositValue: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    getDepositDetails: PropTypes.func,
    addImpositionConf: PropTypes.func,
    updateRenewalPreference: PropTypes.func.isRequired,
    requestInterveners: PropTypes.func.isRequired,
    requestDeposits: PropTypes.func,
    finish: PropTypes.func
}

module.exports.constructor = AddImpositionDepositView;
module.exports.AddImpositionDepositView = connect(state => ({
    immProfileFields: state.profile,
    immImpositionState: state.addImpositionDeposit,
    immAccounts: state.accounts,
    immDeposits: state.deposits,
    immDepositDetails: state.depositsDetails
}), {
    setWillCancel: addImpositionDepositActions.setWillCancel,
    reset: addImpositionDepositActions.reset,
    setVisibleStep: addImpositionDepositActions.setVisibleStep,
    setDepositValue: addImpositionDepositActions.setCurrentDepositImposition,
    validateStep: addImpositionDepositActions.validateStep,
    getDepositDetails: addImpositionDepositActions.getDepositDetails,
    addImpositionConf: addImpositionDepositActions.addImpositionConf,
    updateRenewalPreference: addImpositionDepositActions.updateRenewalPreference,
    requestInterveners: intervenersActions.requestAccountInterveners,
    requestDeposits: depositsActions.requestDeposits,
})(withRouter(AddImpositionDepositView));
